import React, { memo } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
const HoneymoonFund = () => {
  const navigate = useNavigate();
  const honeymoonOptions = [{
    name: 'Flight Tickets Contribution',
    price: '₦500,000'
  }, {
    name: 'Hotel Accommodation (3 Nights)',
    price: '₦350,000'
  }, {
    name: 'Hotel Accommodation (5 Nights)',
    price: '₦550,000'
  }, {
    name: 'Hotel Accommodation (7 Nights)',
    price: '₦750,000'
  }, {
    name: 'Romantic Dinner Experience',
    price: '₦150,000'
  }, {
    name: 'Spa & Wellness Package',
    price: '₦200,000'
  }, {
    name: 'Adventure Activities Package',
    price: '₦180,000'
  }, {
    name: 'City Tour & Sightseeing',
    price: '₦120,000'
  }, {
    name: 'Beach Resort Day Pass',
    price: '₦80,000'
  }, {
    name: 'Couples Photoshoot',
    price: '₦100,000'
  }, {
    name: 'Airport Transfers',
    price: '₦50,000'
  }, {
    name: 'Travel Insurance',
    price: '₦75,000'
  }, {
    name: 'Custom Amount',
    price: 'Your Choice'
  }];
  return <div className="min-h-screen bg-ivory" data-id="element-220">
      <div className="section-container" data-id="element-221">
        <button onClick={() => navigate('/')} className="flex items-center text-gray-700 hover:text-gold mb-8 transition-colors" data-id="element-222">
          <ArrowLeft size={20} className="mr-2" data-id="element-223" />
          Back to Home
        </button>

        <h1 className="section-heading" data-id="element-224">Honeymoon Fund</h1>
        <p className="text-center text-gray-700 max-w-2xl mx-auto mb-12" data-id="element-225">
          Help us create unforgettable memories on our dream honeymoon. Your
          contribution will make our romantic getaway even more special.
        </p>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto" data-id="element-226">
          {honeymoonOptions.map((option, index) => <div key={index} className="bg-white border border-champagne border-opacity-40 p-6 rounded-md shadow-sm" data-id="element-227">
              <h3 className="font-serif text-lg text-gray-800 mb-2" data-id="element-228">
                {option.name}
              </h3>
              <p className="text-gold font-semibold text-xl mb-4" data-id="element-229">
                {option.price}
              </p>
              <button onClick={() => navigate('/gifts/payment', {
            state: {
              item: option.name,
              price: option.price,
              type: 'Honeymoon Fund'
            }
          })} className="w-full px-4 py-2 bg-gold text-white hover:bg-opacity-90 transition-colors duration-300" data-id="element-230">
                Contribute This Amount
              </button>
            </div>)}
        </div>
      </div>
    </div>;
};
export default HoneymoonFund;